import request from './requestWx'

export function clsSatisfactionDetail(query) {
    return request({
        url: '/wxapp/clsSatisfaction/detail',
        method: 'get',
        params: query
    })
}
export function clsSatisfactionSubmit(query) {
    return request({
        url: '/wxapp/clsSatisfaction/submit',
        method: 'post',
        data: query
    })
}